<template>
	<v-date-picker
		class="cursor-pointer"
		:value="value"
		color="green"
		:min-date="minDate"
		:max-date="maxDate"
		@input="changeValue"
	>
		<template #default="{ inputValue, togglePopover }">
			<div class="w-full">
				<label
					class="text-label"
					:for="id"
					>{{ label }}</label
				>
				<div class="datepicker">
					<Icon
						icon="fa-solid:calendar"
						@click="togglePopover({ placement: 'auto-start' })"
					/>
					<div class="text-label w-full">
						<input
							:id="id"
							class="w-full outline-none"
							type="text"
							:placeholder="placeholder || label"
							:readonly="true"
							:value="inputValue"
							@click="togglePopover({ placement: 'auto-start' })"
						/>
					</div>
				</div>
			</div>
		</template>
	</v-date-picker>
</template>

<script lang="ts" setup>
import { Icon } from '@iconify/vue2'

defineProps<{
	id?: string
	label?: string
	placeholder?: string
	value?: string
	minDate?: string
	maxDate?: string
}>()

const emit = defineEmits<{
	(event: 'input', value: string): void
}>()

function changeValue(date: Date) {
	emit('input', date.toISOString())
}
</script>

<style scoped>
input::placeholder {
	@apply text-sm text-[#737576];
}

.datepicker {
	@apply border border-[#737576] rounded-[4px] flex items-center px-2 bg-white gap-2 mt-1;
}

input {
	@apply border-none leading-7;
}
</style>
